// @ts-ignore
import { createApp } from 'vue';
import { lockDesignerStore } from 'js/store/lockDesignerStore';
import router from 'Router/lockDesignerRoutes';
import Toast, { PluginOptions } from 'vue-toastification';
// @ts-ignore
import PerfectScrollbar from 'vue3-perfect-scrollbar';
import { falPlugin } from './fontAwesomeLibraryPlugin';
import LockDesignerRouterWrap from 'Vue/containers/LockDesignerRouterWrap.vue';

namespace BHW.lockDesigner {
    /**
     * Instantiate Vue Application
     */
    let initLockDesignerApp = function () {
        const options: PluginOptions = {
            transition: 'Vue-Toastification__bounce',
            maxToasts: 20,
            newestOnTop: true,
        };
        const ld = createApp(LockDesignerRouterWrap).use(lockDesignerStore).use(falPlugin).use(Toast, options).use(PerfectScrollbar).use(router);
        ld.mount('#lockDesigner');
    };

    export const init = () => {
        initLockDesignerApp();
    };
}

document.addEventListener('DOMContentLoaded', () => {
    BHW.lockDesigner.init();
});
